import axios from "axios";
const { CancelToken } = axios;
const _cancelToken = {};

const AxiosRequest = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});


AxiosRequest.interceptors.request.use(
    (config) => {
        const { cancelToken } = config;
        if (cancelToken) {
            // cancel previous request and delete from queue
            if (_cancelToken[cancelToken]) {
                const source = _cancelToken[cancelToken];
                delete _cancelToken[cancelToken];
                source.cancel();
            }

            // add current request in queue
            const source = CancelToken.source();
            config.cancelToken = source.token;
            _cancelToken[cancelToken] = source;
        }
        // add accessToken header before sending api
        const accessToken = sessionStorage.getItem("token");
      
        config["headers"] = config.headers ?? {};
        (config.headers)["Authorization"] = `Bearer ${accessToken}`;

        return config;
    },
    (error) =>
        Promise.reject(error)
);

AxiosRequest.interceptors.response.use(
    (response) => {
        const { cancelToken } = response.config;
        if (cancelToken) {
            delete _cancelToken[response.config.cancelToken];
        }
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            sessionStorage.clear();
            window.location.href = "/";
        }
        return Promise.reject(error);
    }
);

export default AxiosRequest;